import PoweredBy from './PoweredBy';

export { PoweredBy };
